// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__XgAjP","container":"Benefits_container___m1zc"};